module.exports = __webpack_public_path__ + "img/AndroidMarket.3a03ae63.png";